import { OAuthRedirect } from '../../OAuth/OAuthRedirect';
import { useUpdateOAuthState } from '../../OAuth/useUpdateOAuthState';

const EveryOAuthCallback = () => {
  const { isLoading, postError } = useUpdateOAuthState();

  return <OAuthRedirect isLoading={isLoading} error={postError} />;
};

export default EveryOAuthCallback;
